















































import addressWithLookup from '@/components/address-with-lookup.vue';
import { ClientAccountDeed, createClientAccountDeed } from '@/shared/clients/client-account-deed';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    components: {
        addressWithLookup,
    },
})
export default class AddDeedDialog extends Vue {
    @Prop({ required: true }) public visible!: boolean;

    private isVisible: boolean = this.visible;
    private currentStep: number = 0;
    private addressDetailsValid: boolean = false;
    private deed: ClientAccountDeed = createClientAccountDeed();

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.currentStep = 0;
        this.isVisible = visible;
    }

    private async onNextAsync(): Promise<void> {
        if (!await (this.$refs.address as Vue).$validator.validateAll('address-details')) { return; }

        this.addressDetailsValid = true;

        setTimeout(() => {
            this.currentStep++;
        }, 0);
    }

    private onPrevious(): void {
        this.currentStep--;
    }

    private onSave(): void {
        this.$emit('ok', { ...this.deed });
    }

    private onCancel(): void {
        this.$emit('cancel');
    }
}
